<template>
  <div class="ad-container" v-if="title">
    <span class="text text_xs text_bold">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'TAdBanner',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-container {
  background-color: var(--muted);
  padding: 8px 24px;
  text-align: center;

  .text {
    font-size: 14px;
  }
}
</style>
